import * as React from "react";
import { Link } from "@nextui-org/link";
import { button as buttonStyles } from "@nextui-org/theme";

import sectionImage from "../../public/assets/images/legal.png";
import { title } from "@/components/primitives";
import TermSpyCom from "@/components/terms-spy";

export default function TermsPage() {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="lg:w-5/6 xl:w-5/6 w-full sm:w-all w-full">
        <div
          className="ct-bg-white min-h-80 py-3 lg:px-12 xl:px-12 px-2 rounded-md"
          data-aos="fade-up"
        >
          <div className="flex flex-row gap-4 justify-center items-center">
            <div className="block w-5/6">
              <h4 className={title({ fullWidth: true })}>Terms & Conditions</h4>
              <p className="my-5 pt-4 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                Thanks for taking the time to learn about our terms and
                conditions. This is where you will find information about the
                rules guiding the use of our platform, compliance, what you can
                and can not do with CryptoTX.
              </p>
            </div>
            <div className="w-1/2 hidden xl:block lg:block">
              <div className="flex flex-col items-end justify-center">
                <img
                  alt=""
                  className="w-1/2 self-end"
                  src={sectionImage}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-row gap-4 lg:block xl:bblock justify-center items-center mb-8 pb-10 clear-both">
            <Link
              className={buttonStyles({
                color: "primary",
                radius: "md",
                size: "lg",
                variant: "shadow",
              })}
              href="/contact-us"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      <div>
        <TermSpyCom />
      </div>
    </div>
  );
}
